// Utility functions for diagnostics enrichment and header parsing

/**
 * Checks if the authentication headers pass SPF/DKIM/DMARC checks.
 * @param {object} authHeader
 * @returns {boolean}
 */
export function authPass(authHeader) {
    // 1. If “X-MS-Exchange-Organization-AuthAs” exists and the value is “Internal”, then return pass.
    if (authHeader.authAs && authHeader.authAs === "Internal") {
        return true;
    }
    // If “Authentication-Results” header is missing, then return pass.
    if (authHeader.results === undefined) {
        return true;
    }
    if (!authHeader.results) {
        return false;
    }
    // 3.a. “dmarc=fail”, return fail;
    if (authHeader.results.indexOf('dmarc=fail') !== -1) {
        return false;
    }
    // 3.b. “dmarc=pass” or “dmarc=bestguesspass”, return pass;
    if (authHeader.results.indexOf('dmarc=pass') !== -1 || authHeader.results.indexOf('dmarc=bestguesspass') !== -1) {
        return true;
    }
    // 3.c. “dkim=fail”, return fail;
    if (authHeader.results.indexOf('dkim=fail') !== -1) {
        return false;
    }
    // 3.d. "spf=pass" or "dkim=pass", return pass;
    if (authHeader.results.indexOf('spf=pass') !== -1 || authHeader.results.indexOf('dkim=pass') !== -1) {
        return true;
    }
    return false;
}

/**
 * Parses authentication headers from a string of headers.
 * @param {string} headers
 * @returns {object}
 */
export function getAuthHeader(headers) {
    var authHeader = {};
    var lines = headers.split(/[\n\r]+/);
    var headerList = [];
    var iNextHeader = 0;
    // Unfold lines
    for (var iLine = 0; iLine < lines.length; iLine++) {
        var line = lines[iLine];
        if (line === "") continue;
        var match = line.match(/(^[\w-.]*?): ?(.*)/);
        if (match && match[1] && !match[1].match(/^\d{1,2}$/)) {
            headerList[iNextHeader] = line;
            iNextHeader++;
        } else {
            if (iNextHeader > 0) {
                line = line.replace(/^[\s]+/, "");
                if (!line) continue;
                var separator = headerList[iNextHeader - 1] ? " " : "";
                headerList[iNextHeader - 1] += separator + line;
            } else {
                if (line.match(/\S/g)) {
                    headerList[iNextHeader] = line;
                    iNextHeader++;
                }
            }
        }
    }
    for (var iHeader = 0; iHeader < headerList.length; iHeader++) {
        line = headerList[iHeader];
        if (line.startsWith('X-MS-Exchange-Organization-AuthAs:') && authHeader.authAs === undefined) {
            authHeader.authAs = line.replace('X-MS-Exchange-Organization-AuthAs: ', '');
            continue;
        }
        if (line.startsWith('Authentication-Results:') && authHeader.results === undefined) {
            authHeader.results = line.replace('Authentication-Results: ', '');
            continue;
        }
    }
    return authHeader;
}
